import React, { Component } from 'react'
import QueueNumberPageItemRepository from '../Repository/QueueNumberPageItemRepository'

export const QUEUE_NUMBER_PAGE_DEFAULT_FONT_SIZE = '350';
export const QUEUE_NUMBER_PAGE_FONT_SIZE_LS_KEY = 'QUEUE_NUMBER_PAGE_FONT_SIZE';
export const QUEUE_NUMBER_PAGE_FONT_SIZE_EVENT_CHANGED = 'app.queue-number-page.title-font-size.changed';

export const QUEUE_NUMBER_PAGE_TITLE_DEFAULT_FONT_SIZE = '200';
export const QUEUE_NUMBER_PAGE_TITLE_FONT_SIZE_LS_KEY = 'QUEUE_NUMBER_PAGE_TITLE_FONT_SIZE';
export const QUEUE_NUMBER_PAGE_TITLE_FONT_SIZE_EVENT_CHANGED = 'app.queue-number-page.font-size.changed';

export const QUEUE_NUMBER_PAGE_DEFAULT_LINE_HEIGHT = '1';
export const QUEUE_NUMBER_PAGE_LINE_HEIGHT_LS_KEY = 'QUEUE_NUMBER_PAGE_LINE_HEIGHT';
export const QUEUE_NUMBER_PAGE_LINE_HEIGHT_EVENT_CHANGED = 'app.queue-number-page.line-height.changed';

export const QUEUE_NUMBER_PAGE_DEFAULT_AUDIO_REPEAT_COUNT = '1';
export const QUEUE_NUMBER_PAGE_AUDIO_REPEAT_COUNT_LS_KEY = 'QUEUE_NUMBER_PAGE_AUDIO_REPEAT_COUNT';
export const QUEUE_NUMBER_PAGE_AUDIO_REPEAT_COUNT_EVENT_CHANGED = 'app.queue-number-page.audio-repeat-count.changed';

export const QUEUE_NUMBER_PAGE_DEFAULT_AUDIO_SPEED = '10';
export const QUEUE_NUMBER_PAGE_AUDIO_SPEED_LS_KEY = 'QUEUE_NUMBER_PAGE_AUDIO_SPEED';
export const QUEUE_NUMBER_PAGE_AUDIO_SPEED_EVENT_CHANGED = 'app.queue-number-page.audio-speed.changed';


export const QUEUE_NUMBER_PAGE_DEFAULT_AUDIO_WAIT = '5';
export const QUEUE_NUMBER_PAGE_AUDIO_WAIT_LS_KEY = 'QUEUE_NUMBER_PAGE_AUDIO_WAIT';
export const QUEUE_NUMBER_PAGE_AUDIO_WAIT_EVENT_CHANGED = 'app.queue-number-page.audio-wait.changed';

export const QUEUE_NUMBER_PAGE_DEFAULT_AUDIO_ENABLED = '1';
export const QUEUE_NUMBER_PAGE_AUDIO_ENABLED_LS_KEY = 'QUEUE_NUMBER_PAGE_AUDIO_ENABLED';
export const QUEUE_NUMBER_PAGE_AUDIO_ENABLED_EVENT_CHANGED = 'app.queue-number-page.audio-enabled.changed';

export const QUEUE_NUMBER_PAGE_DEFAULT_SHOW_TABLE_NAME = '1';
export const QUEUE_NUMBER_PAGE_SHOW_TABLE_NAME_LS_KEY = 'QUEUE_NUMBER_PAGE_SHOW_TABLE_NAME';
export const QUEUE_NUMBER_PAGE_SHOW_TABLE_NAME_EVENT_CHANGED = 'app.queue-number-page.show-table-name.changed';

export const QUEUE_NUMBER_PAGE_AUDIO_SETTING_LS_KEY = 'QUEUE_NUMBER_PAGE_AUDIO_SETTING_LS_KEY';
export const QUEUE_NUMBER_PAGE_AUDIO_SETTING_EVENT_CHANGED = 'app.queue-number-page.audio-setting.changed';

import './QueueNumberPage.scss';

class QueueNumberPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            tableSessionWithActiveOrders: [],
            queueNumberFontSize: this.loadFontSize(),
            titleFontSize: this.loadTitleFontSize(),
            lineHeight: this.loadLineHeight(),
        }

        this.callbackKey = "QueueNumberPage"
    }
    componentWillUnmount() {
        QueueNumberPageItemRepository.getDefaultInstance().removeCallback(null, this)
        window.removeEventListener('storage', this.onLocalStorageChange)
        $(document).off(QUEUE_NUMBER_PAGE_FONT_SIZE_EVENT_CHANGED, this.handleFontSizeChangeEvent)
        $(document).off(QUEUE_NUMBER_PAGE_TITLE_FONT_SIZE_EVENT_CHANGED, this.handleTitleFontSizeChangeEvent)
        $(document).off(QUEUE_NUMBER_PAGE_LINE_HEIGHT_EVENT_CHANGED, this.handleLineHeightChangeEvent)
    }
    componentDidMount() {
        this.getQueueNumbers()
        window.addEventListener('storage', this.onLocalStorageChange)
        $(document).on(QUEUE_NUMBER_PAGE_FONT_SIZE_EVENT_CHANGED, this.handleFontSizeChangeEvent)
        $(document).on(QUEUE_NUMBER_PAGE_TITLE_FONT_SIZE_EVENT_CHANGED, this.handleTitleFontSizeChangeEvent)
        $(document).on(QUEUE_NUMBER_PAGE_LINE_HEIGHT_EVENT_CHANGED, this.handleLineHeightChangeEvent)
    }
    componentDidUpdate() {

    }
    getQueueNumbers = () => {
        QueueNumberPageItemRepository.getDefaultInstance().onThrottledResultByGroup(({queueNumberPageItems, ready, preparing}) => {
            console.log("queueNumberPageItems", queueNumberPageItems)
            console.log("ready", ready,)
            console.log("preparing", preparing,)
            this.setState({
                queueNumberPageItems, preparing, ready
            })
        }, this.callbackKey, this)
    }
    loadFontSize = () => {
        let fromLocalStorage = localStorage.getItem(QUEUE_NUMBER_PAGE_FONT_SIZE_LS_KEY)
        return fromLocalStorage === null ? QUEUE_NUMBER_PAGE_DEFAULT_FONT_SIZE : fromLocalStorage
    }
    loadTitleFontSize = () => {
        let fromLocalStorage = localStorage.getItem(QUEUE_NUMBER_PAGE_TITLE_FONT_SIZE_LS_KEY)
        return fromLocalStorage === null ? QUEUE_NUMBER_PAGE_TITLE_DEFAULT_FONT_SIZE : fromLocalStorage
    }
    loadLineHeight = () => {
        let fromLocalStorage = localStorage.getItem(QUEUE_NUMBER_PAGE_LINE_HEIGHT_LS_KEY)
        return fromLocalStorage === null ? QUEUE_NUMBER_PAGE_DEFAULT_LINE_HEIGHT : fromLocalStorage
    }
    handleFontSizeChangeEvent = (e, args) => {
        this.setQueueNumberFontSize(args)
    }
    handleTitleFontSizeChangeEvent = (e, args) => {
        this.setTitleFontSize(args)
    }
    handleLineHeightChangeEvent = (e, args) => {
        this.setLineHeight(args)
    }
    setQueueNumberFontSize = (queueNumberFontSize) => {
        if (queueNumberFontSize != this.state.queueNumberFontSize) {
            this.setState({queueNumberFontSize: queueNumberFontSize})
        }
    }
    setTitleFontSize = (titleFontSize) => {
        if (titleFontSize != this.state.titleFontSize) {
            this.setState({titleFontSize: titleFontSize})
        }
    }
    setLineHeight = (lineHeight) => {
        if (lineHeight != this.state.lineHeight) {
            this.setState({lineHeight: lineHeight})
        }
    }
    onLocalStorageChange = () => {
        let queueNumberFontSize = localStorage.getItem(QUEUE_NUMBER_PAGE_FONT_SIZE_LS_KEY)
        this.setQueueNumberFontSize(queueNumberFontSize)

        let titleFontSize = localStorage.getItem(QUEUE_NUMBER_PAGE_TITLE_FONT_SIZE_LS_KEY)
        this.setTitleFontSize(titleFontSize)

        let lineHeight = localStorage.getItem(QUEUE_NUMBER_PAGE_LINE_HEIGHT_LS_KEY)
        this.setLineHeight(lineHeight)
    }
    render() {
        const { preparing, ready, queueNumberFontSize = QUEUE_NUMBER_PAGE_DEFAULT_FONT_SIZE, titleFontSize = QUEUE_NUMBER_PAGE_TITLE_DEFAULT_FONT_SIZE, lineHeight = QUEUE_NUMBER_PAGE_DEFAULT_LINE_HEIGHT} = this.state
        return (
            <div className="container merchant-queue-number-page">
                {/* Header */}
                <h2 style={{textAlign: "center"}} className="queue-number-page-header">
                    {this.props.app.state.merchant && this.props.app.state.merchant.name}
                </h2>
                <hr/>

                {/* Body to show Queue Number */}
                <div style={{display: "flex"}} className="queue-number-page-body">
                    <div style={{flex: "1 0 100px", textAlign: "center", height: "100%"}} className="queue-number-container-wrapper">
                        <div className="queue-number-title">
                            <u style={{fontSize: `${titleFontSize}%`}}>Preparing</u>
                        </div>
                        <div style={{lineHeight: lineHeight}} className="queue-number-container">
                            <div className="queue-number-list">
                                {
                                    (preparing || []).map(queueNumberData => {
                                        return <div key={queueNumberData.table_session_id} style={{color: "blue", fontSize: `${queueNumberFontSize}%`}}>
                                            <strong>
                                                {queueNumberData.queue_number}
                                            </strong>
                                        </div>
                                    })
                                }
                            </div>
                        </div>
                    </div>
                    <div style={{width: "1px", backgroundColor: "grey", height: "100%"}}></div>
                    <div style={{flex: "1 0 100px", textAlign: "center",}} className="queue-number-container-wrapper">
                        <div className="queue-number-title">
                            <u style={{fontSize: `${titleFontSize}%`}}>Ready</u>
                        </div>
                        <div style={{lineHeight: lineHeight}} className="queue-number-container">
                            <div className="queue-number-list">
                                {
                                    (ready || []).map(queueNumberData => {
                                        return <div key={queueNumberData.table_session_id} style={{color: "green", fontSize: `${queueNumberFontSize}%`,}}>
                                            <strong>
                                                {queueNumberData.queue_number}
                                            </strong>
                                        </div>
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>

                {/* Footer to leave some gap */}
                <div className="queue-number-page-footer">&nbsp;</div>
            </div>
        )
    }
}

export default QueueNumberPage;